import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgLinkIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 800 800"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M506.567 111.821c55.776-55.993 141.686-60.533 191.886-10.139 50.2 50.394 45.677 136.637-10.1 192.63L607.56 375.42m-272.68 91.247c-50.199-50.394-45.677-136.638 10.1-192.631l71.687-71.965"
      stroke="currentColor"
      strokeWidth={50}
      strokeLinecap="round"
      fill="transparent"
    />
    <path
      d="M465.12 333.333c50.2 50.394 45.677 136.637-10.1 192.63l-80.793 81.107-80.794 81.11c-55.777 55.993-141.687 60.53-191.886 10.137-50.2-50.394-45.677-136.637 10.099-192.63l80.795-81.11"
      stroke="currentColor"
      strokeWidth={50}
      strokeLinecap="round"
      fill="transparent"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgLinkStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgLinkIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const LinkIcon: any = SvgLinkStyle;
export default LinkIcon;
